module.exports = __webpack_public_path__ + "static/media/no_minute_1.a26ce135.jpg";